export const MAIN_PAGE_BANNER = 'main-page-banner'